import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { createGetAllQueryForVariant } from '../../pages/measuringPoint/utils';
import { hasAtLeastPermission, PERMISSION, requirePermission } from '../../pages/sharing/utils';
import { defaultPropTypes, useSharedFormContext } from '../utils';
import ChoiceField from './ChoiceField';

function ProjectField({ fieldOptions }) {
    const { formController } = useSharedFormContext();
    const { formState } = useFormContext();
    const assignedProjectId = formState.defaultValues?.[fieldOptions.name];

    const [query, returnKey] = createGetAllQueryForVariant(formController.swarmType, true, false);
    const { data } = useQuery(query);

    const projects = useMemo(() => data?.[returnKey] ?? [], [data, returnKey]);

    // A reference-only project can be shown but not attached, so it is only offered when the
    // measuring point already has it.
    const extraChoiceOptions = useMemo(
        () =>
            projects
                .filter(
                    ({ id, permission }) =>
                        hasAtLeastPermission(
                            requirePermission(permission, `project "${id}"`),
                            PERMISSION.View
                        ) || String(id) === String(assignedProjectId)
                )
                .map(({ id, name }) => [id, name]),
        [projects, assignedProjectId]
    );

    return (
        <ChoiceField
            fieldOptions={fieldOptions}
            extraChoiceOptions={extraChoiceOptions}
            addOptionWhenMissing={true}
        />
    );
}
ProjectField.propTypes = defaultPropTypes;

export default ProjectField;
